import {connect} from 'react-redux';

import decorate from '../../../utils/decorate';
import {Map} from 'immutable';

import { AuditDetails } from './AuditDetails.tsx';

import {request as getAudit} from '../../../modules/audits/actions/get';

function mapStateToProps(state, props) {
    let auditDiff = state.audits.getIn([ 'auditDiff' , parseInt(props.audit_id, 10), 'audit', 'diff' ]);
    let audits = state.audits.getIn(['collections', props.id ]);

    if (!audits || !audits.get || !audits.get('items')) {
        return {
            audits: null,
            auditDiff: auditDiff ? auditDiff.toJS() : auditDiff
        };
    }

    const auditItems = audits.toJS().items;
    const auditId = typeof props.audit_id === 'string' ? props.audit_id : String(props.audit_id);
    const foundAudit = auditItems.find(o => String(o.id) === auditId);

    return {
        audits: foundAudit || null,
        auditDiff : auditDiff ? auditDiff.toJS() : auditDiff
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onGetAuditDiffRequest: (id) => dispatch(getAudit(id))
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    AuditDetails
);
